import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0b71349c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "h-main"
};
var _hoisted_2 = {
  class: "h-left"
};
var _hoisted_3 = {
  class: "menu"
};
var _hoisted_4 = {
  class: "item"
};
var _hoisted_5 = {
  class: "cell"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

var _hoisted_7 = {
  class: "submenu"
};
var _hoisted_8 = {
  class: "cell"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

var _hoisted_10 = {
  class: "cell"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

var _hoisted_12 = {
  class: "h-right"
};
var _hoisted_13 = {
  class: "preview-wrap"
};
var _hoisted_14 = {
  class: "preview-content"
};
var _hoisted_15 = {
  class: "book animated"
};
import { ref } from 'vue';
import Search from '@/components/common/lineSearch';
import pdf from 'vue3-pdf';
export default {
  setup: function setup(__props) {
    var url = 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf';
    var pageCount = ref(100);
    var currentPage = ref(1);

    var addPage = function addPage() {
      console.log(pageCount.value);
      console.log(currentPage.value);
      var page = currentPage.value < pageCount.value ? currentPage.value + 1 : 1;
      currentPage.value = page;
    };

    var backPage = function backPage() {
      var page = currentPage.value > 1 ? currentPage.value - 1 : pageCount.value;
      currentPage.value = page;
    };

    var getPageCount = function getPageCount(e) {
      console.log(e);
    };

    getPageCount();
    return function (_ctx, _cache) {
      var _component_folder_opened = _resolveComponent("folder-opened");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_document = _resolveComponent("document");

      var _component_d_arrow_right = _resolveComponent("d-arrow-right");

      var _component_d_arrow_left = _resolveComponent("d-arrow-left");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Search)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_folder_opened)];
        }),
        _: 1
      }), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_document)];
        }),
        _: 1
      }), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_document)];
        }),
        _: 1
      }), _hoisted_11])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        class: "next-button",
        onClick: addPage
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_d_arrow_right)];
        }),
        _: 1
      })]), _createElementVNode("div", {
        class: "previous-button",
        onClick: backPage
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_d_arrow_left)];
        }),
        _: 1
      })]), _createTextVNode(" " + _toDisplayString(currentPage.value) + " / " + _toDisplayString(pageCount.value) + "/" + _toDisplayString(_ctx.error) + " ", 1), _createVNode(_unref(pdf), {
        src: url,
        page: currentPage.value,
        onNumPages: getPageCount,
        onPageLoaded: _cache[0] || (_cache[0] = function ($event) {
          return currentPage.value = $event;
        })
      }, null, 8, ["page"])])])])])]);
    };
  }
};